module.exports = __webpack_public_path__ + "media/images/client-16-b7cc42530a74d351cc40432fcfdd5976.png";